import { useEffect } from "react";
import { useNavigate, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import Menu from "./components/Menu";
import Apps from "./components/Apps";
import Berichten from "./components/Messages";
import LoginPage from "./components/LoginPage";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // ⏱️ Start timer voor 1 uur sessie
        const timer = setTimeout(() => {
          auth.signOut().then(() => {
            navigate("/"); // 🔁 Redirect naar login na uitloggen
          });
        }, 60 * 60 * 1000); // 1 uur in ms
        return () => clearTimeout(timer);
      }
    });

    return () => unsubscribe(); // 🧹 Stop luisteren bij unmount
  }, [navigate]);

  return (
    <>
      <Menu />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/apps" element={<PrivateRoute element={<Apps />} />} />
        <Route
          path="/berichten"
          element={<PrivateRoute element={<Berichten />} />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
